<script lang='ts'>
  import Modal from '@shared/svelte/Components/Modal.svelte';
  import TwitterShare from '@shared/svelte/Components/SocialMediaShare/TwitterShare.svelte';
  import FacebookShare from '@shared/svelte/Components/SocialMediaShare/FacebookShare.svelte';
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';

  export let showShareStorefrontModal: boolean = false;
  export let storefront:Storefront;
  export let closeShareStorefrontModal: () => void;

  //@ts-ignore
  const APPURL = window.C.APP_URL
  let shareUrl = APPURL + "/"
  let title = 'View our latest portfolio and order directly from our Storefront on Provi'

  function copyToClipboard() {
    navigator.clipboard.writeText(shareUrl + storefront.published_urls[0].short_url)
  }

  function selectTextOnFocus(node: any) {

    const handleFocus = () => {
      node && typeof node.select === 'function' && node.select()
    }

    node.addEventListener('focus', handleFocus)

    return {
      destroy() {
        node.removeEventListener('focus', handleFocus)
      }
    }
  }

  function prepUrls() {
    if (!storefront.published_urls) {
      storefront.published_urls = [];
    }
    return storefront.published_urls;
  }


</script>

<Modal bind:show={showShareStorefrontModal} closeOnBackgroundClick={false}>
<div style="width: 90vw; max-width: 850px;">
  <header class="modal__header padding--small align-left default-title--regular">
    Share Storefront
  </header>
  <div class="default-body--regular flex-col">
    <div class="padding--small">Get the link to share on social</div>
      {#each prepUrls() as url}
        <div class="input-wrapper margin--small">
          <input class="input" type='text' name='readonly-share-link' use:selectTextOnFocus
          value='{APPURL}/{url.short_url}' on:click={copyToClipboard} readonly/>
        </div>

        <ul class="fizz-flex-row-4 padding--small">
          <FacebookShare url={shareUrl + url.short_url} />
          <TwitterShare text="{title}" url={shareUrl + url.short_url} />
        </ul>
      {/each}
      {#if storefront.published_urls.length == 0}
        (Publish your storefront to get a link)
      {/if}
      <div>
    </div>
  </div>
  <footer class="modal__footer align-right padding--small">
    <button class="button button--small button--primary" style='font-size: 14px !important;' on:click={closeShareStorefrontModal}>Done</button>
  </footer>
  </div>
</Modal>